module.exports = __webpack_public_path__ + "img/geng-glowing.4c256459.png";